// useRenderCounts.ts
import { Subscription } from 'rxjs';
import { useEffect, useState } from 'react';

import { type ContextMenuData } from './types/context-menu-data.type';
import { contextMenuService } from './context-menu-service';
import { emptyContextMenuData } from './helpers/empty-context-menu-data';

export type UseContextMenu = [
	ContextMenuData,
	{
		setSvg: (svgElement: SVGElement | SVGSVGElement | null) => void;
	}
];

export const useContextMenu = (): UseContextMenu => {
	const [context, setContext] = useState<ContextMenuData>(emptyContextMenuData());

	useEffect(() => {
		const sub: Subscription = contextMenuService.getContext$().subscribe(setContext);
		return () => sub.unsubscribe();
	}, []);

	const handleSetSvg = (svgElement: SVGElement | SVGSVGElement | null) => {
		if (svgElement) {
			if (svgElement instanceof SVGSVGElement) {
				contextMenuService.setSvg(svgElement);
			} else {
				const tempSvg = svgElement.ownerSVGElement as SVGSVGElement | null;
				contextMenuService.setSvg(tempSvg);
			}
		} else {
			contextMenuService.setSvg(null);
		}
	};

	return [context, { setSvg: handleSetSvg }];
};
